<script>
import { mapActions } from "vuex";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";

export default {
	name: "compKeluargaKatolikModal",
	components: {
		VueGoodTable,
	},
	props: ["triggerValidation"],
	data() {
		return {
			isLoading: false,
			columns: [
				{
					label: "Nomor",
					field: "nomor",
					sortable: false,
				},				
            {
					label: "Nama Kepala keluarga",
					field: "kepala_keluarga",
					sortable: false,
				},
				{
					label: "Paroki",
					field: "paroki",
					sortable: false,
				},				
            {
					label: "Lingkungan/Stasi",
					field: "lingkungan_stasi",
					sortable: false,
				},
				{
					label: "Action",
					field: this.actionFn,
					sortable: false,
               html: true,
               tdClass: 'text-center',
               thClass: 'text-center',
				},
			],
			rows: [],
			totalRecords: 0,
			serverParams: {
				columnFilters: {},
				sort: {
					field: "",
					type: "",
				},
				search: "",
				page: 1,
				perPage: 10,
			},
		};
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	mounted() {
		this.loadItems();
	},
	methods: {
		...mapActions({
			getKK: "service/getKK",
		}),
		updateParams(newProps) {
			this.serverParams = Object.assign({}, this.serverParams, newProps);
		},

		onPageChange(params) {
			this.updateParams({ page: params.currentPage });
			this.loadItems();
		},

		onPerPageChange(params) {
			this.updateParams({ perPage: params.currentPerPage });
			this.loadItems();
		},

		onSortChange(params) {
			this.updateParams({
				sort: [
					{
						type: params.sortType,
						field: this.columns[params.columnIndex].field,
					},
				],
			});
			this.loadItems();
		},

		onColumnFilter(params) {
			this.updateParams(params);
			this.loadItems();
		},

		// load items is what brings back the rows from server
		async loadItems() {
			await this.getKK(this.serverParams).then((response) => {
				console.log(response);
				this.totalRecords = response.data.totalRecords;
				this.rows = response.data.rows;
			});
		},
		onRowClick(params) {
			this.$emit("onRowClick", params.row.uid);
		},
		createOptions(data) {
			return data.map((item) => {
				return { text: item, value: item };
			});
		},
		onSearch(params) {
			console.log(params);
			this.serverParams.search = params;
			this.loadItems();
		},
		actionFn() {
			return `
            <div role="group" class="btn-group">
               <button title="Info" type="button" class="btn btn-outline-dark btn-sm"><i class="fa fa-check"></i></button>
            </div>
            `;
		},
	},
};
</script>

<template>
	<div>
		<vue-good-table
			mode="remote"
			@on-page-change="onPageChange"
			@on-sort-change="onSortChange"
			@on-column-filter="onColumnFilter"
			@on-per-page-change="onPerPageChange"
			:totalRows="totalRecords"
			:isLoading.sync="isLoading"
			:pagination-options="{
				enabled: true,
			}"
			:rows="rows"
			:columns="columns"
			:search-options="{
				enabled: true,
				trigger: 'enter',
			}"
			:line-numbers="true"
			@on-row-click="onRowClick"
			@on-search="onSearch"
		/>
	</div>
</template>

